/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const LOCKED_API_FIELDS = ['external_id', 'fname', 'lname'];

const __vue_script__ = {
    name: 'MapFieldsModal',

    components: {
        BaseSelect,
    },

    props: {
        mappings: {
            type: Object,
            default: () => ({}),
        },

        save: {
            type: Function,
            default: null,
        },

        metadataFields: {
            type: Object,
            required: true
        },

        apiFields: {
            type: Array,
            required: true
        },
    },

    data() {
        const metadataFields = {...this.metadataFields};
        if (!metadataFields.fp_ext_id) {
            metadataFields.fp_ext_id = {};
        }
        return {
            innerValue: { ...this.mappings },
            metadataOptions: Object.entries(metadataFields).map(
                ([fieldName, field]) => ({ value: fieldName, label: `${field.label || fieldName} [${fieldName}]` })
            )
        };
    },

    methods: {
        isLockedApiField(apiField) {
            return LOCKED_API_FIELDS.includes(apiField);
        },

        availableMetadataOptions(apiField) {
            let mappedFields = new Set(Object.values(this.innerValue));
            const currentValue = this.innerValue[apiField];

            if (currentValue) {
                mappedFields.delete(currentValue);
            }

            return this.metadataOptions.filter(({ value }) => !mappedFields.has(value));
        },

        async submit() {
            if (this.save) {
                // remove empty mappings
                const mapping = Object.entries(this.innerValue).reduce((acc, [apiField, mdField]) => {
                    if (mdField) {
                        acc[apiField] = mdField;
                    }
                    return acc;
                }, {});
                await this.save(mapping);
            }

            this.$emit('close');
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-wrapper map-fields-modal"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit("close")}}}),_c('h3',[_vm._v(_vm._s(_vm.$t('leads.settings.field_mapping_modal.title')))])]),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.field_mapping_modal.description')))]),_vm._l((_vm.apiFields),function(apiField){return _c('div',{key:apiField,staticClass:"mapping-row"},[_c('base-select',{attrs:{"name":("mapping_" + apiField),"label":_vm.$t('leads.settings.field_mapping_modal.api_field', { field: apiField }),"options":_vm.availableMetadataOptions(apiField),"emitOptionValueOnly":true,"track-by":"value","placeholder":_vm.$t('leads.settings.field_mapping_modal.metadata_placeholder'),"disabled":_vm.isLockedApiField(apiField)},model:{value:(_vm.innerValue[apiField]),callback:function ($$v) {_vm.$set(_vm.innerValue, apiField, $$v)},expression:"innerValue[apiField]"}})],1)})],2),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit("close")}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MapFieldsModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__